import { inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackBarMessageComponent } from './snack-bar-message.component';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  private snackbar = inject(MatSnackBar);

  error(message: string) {
    this.snackbar.openFromComponent(SnackBarMessageComponent, {
      data: { message },
      duration: 5000,
      panelClass: ['snack-error'],
      verticalPosition: 'top',
      horizontalPosition: 'right',
    });
  }

  success(message: string) {
    this.snackbar.openFromComponent(SnackBarMessageComponent, {
      data: { message },
      duration: 5000,
      panelClass: ['snack-success'],
      verticalPosition: 'top',
      horizontalPosition: 'right',
    });
  }

  info(message: string) {
    this.snackbar.openFromComponent(SnackBarMessageComponent, {
      data: { message },
      duration: 5000,
      panelClass: ['snack-info'],
      verticalPosition: 'top',
      horizontalPosition: 'right',
    });
  }

  warning(message: string) {
    this.snackbar.openFromComponent(SnackBarMessageComponent, {
      data: { message },
      duration: 5000,
      panelClass: ['snack-warning'],
      verticalPosition: 'top',
      horizontalPosition: 'right',
    });
  }
}
